export default __webpack_public_path__ + "static/media/id-in-response.aa3266b5.png";